export default class EventsListEntry {
    constructor() {
        this.filters = null;
        this.events = null;
        this.updateInterval = null;
        this.placeholder = null;
        this.discoverButton = null;
    }

    static init() {
        const instance = new EventsListEntry();
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => instance.setup());
        } else {
            instance.setup();
        }
    }

    setup() {
        this.filters = document.querySelectorAll('.event-filter');
        this.events = document.querySelectorAll('.event');
        this.placeholder = document.querySelector('.events-placeholder');
        this.discoverButton = this.placeholder?.querySelector('.btn-go');

        if (!this.filters.length || !this.events.length) return;

        this.bindEvents();
        this.filterEvents('upcoming');

        // Start periodic updates
        this.startPeriodicUpdate();
    }

    bindEvents() {
        this.filters.forEach(filter => {
            filter.addEventListener('click', (e) => {
                this.updateActiveFilter(e.target);
                this.filterEvents(e.target.dataset.filter);
            });
        });

        // Ajouter l'événement pour le bouton "Je découvre"
        if (this.discoverButton) {
            this.discoverButton.addEventListener('click', () => {
                // Trouver le filtre "past" et le déclencher
                const pastFilter = Array.from(this.filters).find(filter =>
                    filter.dataset.filter === 'past'
                );
                if (pastFilter) {
                    this.updateActiveFilter(pastFilter);
                    this.filterEvents('past');
                }
            });
        }
    }

    updateActiveFilter(clickedFilter) {
        this.filters.forEach(filter => {
            filter.classList.remove('active');
            filter.setAttribute('aria-pressed', 'false');
        });
        clickedFilter.classList.add('active');
        clickedFilter.setAttribute('aria-pressed', 'true');
    }

    filterEvents(filterType) {
        const currentTime = new Date().getTime();
        let visibleEventsCount = 0;

        this.events.forEach(event => {
            const eventDate = event.dataset.date;
            const eventDateTime = new Date(eventDate).getTime();

            const shouldHide = filterType === 'upcoming'
                ? eventDateTime < currentTime
                : eventDateTime >= currentTime;

            if (shouldHide) {
                event.classList.add('hidden');
                event.style.opacity = '0';
                event.style.display = 'none';
                event.style.transition = 'opacity 0.3s ease-out';
            } else {
                event.classList.remove('hidden');
                event.style.opacity = '1';
                event.style.display = 'block';

                event.style.transition = 'opacity 0.3s ease-in';
                visibleEventsCount++;
            }
        });

        // Gestion du placeholder
        if (this.placeholder) {
            if (filterType === 'upcoming' && visibleEventsCount === 0) {
                this.placeholder.classList.remove('hidden');
                this.placeholder.style.opacity = '1';
                this.placeholder.style.display = 'flex';
                this.placeholder.style.transition = 'opacity 0.3s ease-in';
            } else {
                this.placeholder.classList.add('hidden');
                this.placeholder.style.opacity = '0';
                this.placeholder.style.display = 'none';

                this.placeholder.style.transition = 'opacity 0.3s ease-out';
            }
        }
    }

    startPeriodicUpdate() {
        // Update every minute to ensure accurate filtering
        this.updateInterval = setInterval(() => {
            const activeFilter = document.querySelector('.event-filter.active');
            if (activeFilter) {
                this.filterEvents(activeFilter.dataset.filter);
            }
        }, 60000); // 60000ms = 1 minute
    }

    destroy() {
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
        }

        this.filters.forEach(filter => {
            filter.removeEventListener('click', this.filterEvents);
        });

        if (this.discoverButton) {
            this.discoverButton.removeEventListener('click', this.handleDiscoverClick);
        }
    }
}